/** Dependencies */
import angular from 'angular';
// TODO: https://graystep.atlassian.net/browse/GR-2153
import webSpinner from '../webspinner-ajs/webspinner-ajs';
/** Methods */
import { DomToolsService } from './services/DOMTools';
import { paceWebPaymentConfig } from './services/PaymentsData/pace/WebPayment';
import { webPaymentConfig } from './services/PaymentsData/WebPayment';

/*******************************************************************************
 * @ngdoc  overview
 * @module csm.payments
 * @description
 * Payments API client side components.
 *******************************************************************************/
export default angular
  .module('csm.payments.services', [webSpinner])
  .service('DOMTools', DomToolsService)
  .config(webPaymentConfig)
  .config(paceWebPaymentConfig).name;
